import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [''];

  close(): void {
    this.element.classList.add('close');
  }
}
